import { createSelector } from '@reduxjs/toolkit';

import { ModelCategory } from '@paragon/contract-library';
import { getLayoutModelsWithPendingChanges, PathUtilities } from '@paragon/layout-models';

import { ProjectActionScope } from '../projectActionScope';
import { RootState } from '../slices';

export const getSelectedModel = createSelector(
  (state: RootState) => state.grid.selectedPath,
  getLayoutModelsWithPendingChanges,
  (selectedPath, layoutModels) => {
    if (selectedPath == null) {
      return null;
    }

    return layoutModels[PathUtilities.getGuid(selectedPath)] ?? null;
  },
);

const getCheckedRows = (state: RootState) => state.grid.checkedRows;
export const getSelectedPath = (state: RootState) => state.grid.selectedPath;

const getCheckedComponentDesignPaths = createSelector(
  getLayoutModelsWithPendingChanges,
  getCheckedRows,

  (layoutModels, checkedRows) =>
    checkedRows.filter(
      (rowPath) => layoutModels[PathUtilities.getGuid(rowPath)]?.category === ModelCategory.ComponentDesign,
    ),
);

const getCheckedProjectPaths = createSelector(getCheckedRows, (checkedRows) =>
  checkedRows.filter((rowPath) => PathUtilities.isProject(rowPath)),
);

export const getCheckedProjectGuids = createSelector(getCheckedProjectPaths, (projectPaths) =>
  projectPaths.map(PathUtilities.getGuid),
);

export const getCheckedRowsScope = createSelector(
  [getCheckedRows, getCheckedComponentDesignPaths],
  (rowPaths, componentDesignPaths): ProjectActionScope => ({ rowPaths, componentDesignPaths }),
);
